import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { eps } from './url.service'
import { SalaryComponent } from '../store/salary-components/salary-components.state'
import { catchError, map, Observable, throwError } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class SalaryComponentsService {
  private http = inject(HttpClient)
  private getComponentsApi = eps.company.salaryComponentsApi

  loadSalaryComponents(
    componentType: string,
    belongsTo: string | null
  ): Observable<SalaryComponent[]> {
    let params = new HttpParams()
    params = params.set('componentType', componentType)
    if (belongsTo) {
      params = params.set('belongsTo', belongsTo)
    }

    return this.http.get<SalaryComponent[]>(this.getComponentsApi, { params }).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }

  addSalaryComponent(component: SalaryComponent): Observable<SalaryComponent> {
    return this.http.post<SalaryComponent>(this.getComponentsApi, { ...component }).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }

  updateSalaryComponent(id: string, component: SalaryComponent): Observable<SalaryComponent> {
    return this.http.put<SalaryComponent>(`${this.getComponentsApi}/${id}`, { ...component }).pipe(
      map(response => response),
      catchError(error => throwError(() => error))
    )
  }

  deleteSalaryComponent(id: string): Observable<{ message: string; status: string }> {
    return this.http
      .delete<{
        message: string
        status: string
      }>(`${this.getComponentsApi}/${id}`)
      .pipe(
        map(response => response),
        catchError(error => throwError(() => error))
      )
  }
}
